import { Flex } from '@chakra-ui/react'
import { RiLoader2Fill } from 'react-icons/ri'

interface Props {
  height?:string
}

const Loading : React.FC<Props> = ({height = "90vh"}) => {
  return (
    <Flex w='100%' h={height}  justifyContent='center' alignItems='center' >
        <RiLoader2Fill size={30} className='animate-spin' />
    </Flex>
  )
}

export default Loading